/**
 * Copyright 2025 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */

/**
 * Creates a date range object with start and end dates for eligibility checking
 * @param startDate - String date in format 'YYYY-MM-DD'
 * @param endDate - String date in format 'YYYY-MM-DD'
 * @returns Object with start and end Date objects, or null if dates are missing
 */
export const getEligibilityDates = (startDate: string, endDate: string) => {
  if (!startDate || !endDate) {
    return null;
  }

  return {
    start: new Date(`${startDate} 00:00:00`),
    end: new Date(`${endDate} 23:59:59`),
  };
};

/**
 * Checks if current time falls within the eligibility period
 * @param eligibilityDates - Object containing start and end Date objects
 * @returns boolean - true if current time is within eligibility period, false otherwise
 */
export const isWithinEligibilityPeriod = (eligibilityDates: { start: Date; end: Date } | null) => {
  if (!eligibilityDates) {
    return false;
  }

  const currentTime = Date.now();
  return (
    currentTime >= eligibilityDates.start.getTime() && currentTime <= eligibilityDates.end.getTime()
  );
};
